import React from "react";
var __jsx = React.createElement;
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** A single clickable row showing resource type icon, name, and formatted date. */
export function RecordRow(_ref) {
  var recordId = _ref.recordId,
    tab = _ref.tab,
    icon = _ref.icon,
    name = _ref.name,
    date = _ref.date,
    onViewRecords = _ref.onViewRecords;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "linked-record-row-".concat(recordId),
    role: "button",
    tabIndex: 0,
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.LINKED_RECORD_ROW);
      onViewRecords(tab);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter") {
        trackEvent(ANALYTICS_EVENTS.LINKED_RECORD_ROW);
        onViewRecords(tab);
      }
    },
    className: "flex items-center justify-between px-3 py-2.5 bg-sds-base-secondary rounded-sds-200 cursor-pointer hover:bg-sds-base-tertiary transition-colors"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 min-w-0"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: icon,
    className: "w-3.5 h-3.5 shrink-0 text-sds-base-default"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small-strong text-sds-base-default truncate",
    title: name
  }, name)), /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-base italic text-sds-base-secondary shrink-0 ml-3"
  }, date));
}